import {
  Autocomplete,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import CustomButton from '../../../../../../../../../lib/designSystem/Button';

interface DocumentSelectorProps {
  suggestions: any[];
  documents: string[];
  setDocuments: (documents: string[]) => void;
  handleConfirm: () => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

const DocumentSelector = (props: DocumentSelectorProps) => {
  const { suggestions, documents, setDocuments, handleConfirm, open, setOpen } =
    props;
  const [selectedDocuments, setSelectedDocuments] = useState<any[]>([]);

  const handleChangeDocuments = (event: any, newValue: any[]) => {
    setSelectedDocuments(newValue);
    const documentIds = newValue.map((doc: any) => doc.id);
    setDocuments(documentIds);
  };

  const handleConfirmSelection = () => {
    handleConfirm();
    setSelectedDocuments([]);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedDocuments([]);
    setDocuments([]);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">
          Seleccionar Documentos para Prórroga
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: 16 }}
        >
          Selecciona los documentos que deseas incluir en la prórroga. Puedes
          seleccionar múltiples documentos.
        </Typography>

        <Autocomplete
          multiple
          options={suggestions}
          value={selectedDocuments}
          onChange={handleChangeDocuments}
          getOptionLabel={(option: any) =>
            `${option.folio} | ${option.businessName} | ${option.stakeholderName}`
          }
          renderInput={(params: any) => (
            <TextField
              {...params}
              label="Buscar documentos por folio, cliente o deudor"
              placeholder="Selecciona documentos..."
            />
          )}
          filterSelectedOptions
          fullWidth
        />

        {selectedDocuments.length > 0 && (
          <Box mt={2}>
            <Typography variant="body2" color="textSecondary">
              Documentos seleccionados: {selectedDocuments.length}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={handleClose} color="secondary">
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={handleConfirmSelection}
          color="primary"
          disabled={selectedDocuments.length === 0}
        >
          Confirmar ({selectedDocuments.length})
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentSelector;
